/**
 * Branding in one place. The client's name and logo are not known yet (PRD §13); when
 * they are, change this file (and public/icons, manifest.webmanifest, index.html meta —
 * see docs/DESIGN.md "Rebranding"). Nothing else in the app hard-codes the name.
 */
export const BRAND = {
  /** Product wordmark shown in the sidebar, sign-in and title bar. */
  product: 'EROS',
  /** One line under the wordmark on the sign-in screen. */
  tagline: 'Pawnshop inventory and sales',
  /** The client business. Shown on documents and the sign-in screen once known. */
  clientName: '' as string,
  /** Optional client logo (served from /public). Empty = the EROS hang-tag wordmark. */
  clientLogoUrl: '' as string,
  /** Who runs the service, for the footer and Help. */
  operator: 'ITCORE Solutions Inc.',
  supportEmail: 'support@itcore-apps.com',
  /** Browser tab title suffix: "Items · EROS" style is avoided; we use "Items — EROS". */
  titleSuffix: 'EROS',
} as const;

export const pageTitle = (title?: string): string => (title ? `${title} – ${BRAND.titleSuffix}` : BRAND.titleSuffix);
